import {
    FETCH_DOMAIN_NOTES_REQUEST,
    FETCH_DOMAIN_NOTES_SUCCESS,
    FETCH_DOMAIN_NOTES_FAILURE,
    POST_DOMAIN_NOTE_REQUEST,
    POST_DOMAIN_NOTE_SUCCESS,
    POST_DOMAIN_NOTE_FAILURE,
} from '../actions/types/domain-notes-action-types';


import { combineReducers } from 'redux';

function isLoading( state = false, action ){
    let newState;
    switch( action.type ){
        case FETCH_DOMAIN_NOTES_REQUEST:
        case POST_DOMAIN_NOTE_REQUEST:
            newState = true;
            break;
        case FETCH_DOMAIN_NOTES_SUCCESS:
        case FETCH_DOMAIN_NOTES_FAILURE:
        case POST_DOMAIN_NOTE_SUCCESS:
        case POST_DOMAIN_NOTE_FAILURE:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}

function byId( state = {}, action ){
    let newState;
    switch( action.type ){
        case FETCH_DOMAIN_NOTES_SUCCESS:
            newState = action.byId;
            break;
        case FETCH_DOMAIN_NOTES_REQUEST:
        case FETCH_DOMAIN_NOTES_FAILURE:
            newState = {};
            break;
        case POST_DOMAIN_NOTE_SUCCESS:
            newState = {
                [action.response.id]: {
                    ...action.response,
                },
                ...state,
            };
            break;
        default:
            return state;
    }

    return newState;
}

function allIds( state = [], action ){
    let newState;
    switch( action.type ){
        case FETCH_DOMAIN_NOTES_SUCCESS:
            newState = action.allIds;
            break;
        case FETCH_DOMAIN_NOTES_REQUEST:
        case FETCH_DOMAIN_NOTES_FAILURE:
            newState = [];
            break;
        case POST_DOMAIN_NOTE_SUCCESS:
            newState = [
                action.response.id,
                ...state,
            ];
            break;
        default:
            return state;
    }

    return newState;
}

const errorMessage = ( state = '', action ) => {
    let newState;
    switch( action.type ){
        case POST_DOMAIN_NOTE_FAILURE:
            newState = action.error.message;
            break;
        default:
            return state;
    }

    return newState;
};

export default combineReducers( {
    allIds,
    byId,
    errorMessage,
    isLoading,
} );
